import {
  dealerReturn,
  dealerTransfer,
  dispatchDealer,
  getNextPendingNoticeList,
  noticeRecall,
  ProcessedNotice,
  SalesTransfer
} from '@api/announcement';
import {
  DealerTransferInterface,
  DispatchDealerInterface
} from '@api/announcement/type';
import {
  getProjectListByNoticeCode,
  projectDetail,
  updateProject
} from '@api/project';
import stepCheckedIcon from '@assets/image/stepChecked.svg';
import stepUncheckedIcon from '@assets/image/stepUnchecked.svg';
import ZeissButton from '@components/button';
import { CreateProject } from '@components/ProjectFromComponents/CreateProject';
import { PROJECT_MODE } from '@components/ProjectFromComponents/data';
import RevertModal from '@components/revertModal';
import ZeissModal from '@components/zeiss-modal';
import { ROLE_KEYS_MAP } from '@constants';
import { userInfo } from '@store';
import { getCityItem, getDomianRelativeUrl } from '@utils/tool';
import {
  DataFlagEnum,
  NOTICE_STATUS
} from '@views/pages/AnnouncementList/announcement';
import { ShowSalesModalStatusEnum } from '@views/pages/AnnouncementList/tool';
import { Button, Form, message, Space } from 'antd';
import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecoilState } from 'recoil';
// import { useSalesForm } from '../../Footer/Form/useSalesForm';
import { AnnFooterPopup } from '../../Footer/Popup/annFooterPopup';
import { NextNoticePopup } from '../NextNoticePopup/NextNoticePopup';
import './index.scss';
import { ReloadOutlined } from '@ant-design/icons';

export const useForwardAnnouncement = ({
  details = {},
  getAnnInfo,
  checkFirstNotice,
  systemCity,
  dict,
  checkNeedOperation,
  isFinishAction,
  isReturnAction
}: any) => {
  const [open, setOpen] = useState(false);
  const [delearModalOpen, setDelearModalOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [isNextNoticeOpen, setIsNextNoticeOpen] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [projectList, setProjectList] = useState<any>([]);
  const [noticeList, setNoticeList] = useState<any>([]);
  const [curProject, setCurProject] = useState<any>({});
  const [curProjectIndex, setCurProjectIndex] = useState<any>(0);
  const [form] = Form.useForm();
  const [userInfos] = useRecoilState(userInfo);
  const navigate = useNavigate();
  const [returnModalShow, setReturnModalShow] = useState<boolean>(false); // 退回
  const [revertModalShow, setRevertModalShow] = useState<boolean>(false); // 撤回

  const stepItems = useMemo(
    () =>
      projectList?.map((v: any, index: number) => {
        return {
          // title: v.projectName,
          title: `项目${index + 1}`,
          // title: index + 1 === projectList.length ? '完成' : `项目${index + 1}`,
          icon:
            index <= curProjectIndex ? (
              <img src={stepCheckedIcon} alt="" />
            ) : (
              <img src={stepUncheckedIcon} alt="" />
            )
        };
      }) || [],
    [projectList, curProject]
  );

  const isForward_disabled = useMemo(
    () =>
      (details.subjectMatter || []).every((x: any) => {
        return x.subjectMatterStatus !== 0;
      }),
    [details.subjectMatter]
  );

  // const { salesForm } = useSalesForm({
  //   details,
  //   form,
  //   noCapsuleTabs: true,
  //   type: 'sales',
  //   sectorName: details.sectorTypeValue
  // });

  const forwardAnn = async () => {
    const isNeedOperation = await checkNeedOperation?.();
    if (!isNeedOperation) return;
    // if (!isForward_disabled) return
    if (details?.isFirst) {
      setOpen(!open);
      return;
    }
    checkFirstNotice(() => {
      setOpen(!open);
    });
  };

  const getNextNoticeList = () =>
    getNextPendingNoticeList({ noticeCode: details.noticeCode });

  const getProjectList = () =>
    getProjectListByNoticeCode({ noticeCode: details.noticeCode });

  // isShowSalesModal 1 显示 2 不显示
  const goToDetailPage = (
    record: any,
    isShowSalesModal: ShowSalesModalStatusEnum = ShowSalesModalStatusEnum.HIDE
  ) => {
    window.open(
      `${getDomianRelativeUrl()}/announcement/announcementDetail?noticeId=` +
        record?.noticeCode +
        `&isShowSalesModal=${isShowSalesModal}`
    );
  };

  // 处理下一个公告
  const nextNoticeHandleOk = () => {
    goToDetailPage(noticeList?.[0] || {});
    nextNoticeModalCloseHandle();
  };

  const nextNoticeModalCloseHandle = () => {
    setIsNextNoticeOpen(false);
  };
  const nextNoticeModalOpenHandle = () => {
    setIsNextNoticeOpen(true);
  };
  const modalCloseHandle = () => {
    setConfirmOpen(false);
  };
  const modalOpenHandle = () => {
    setConfirmOpen(true);
  };
  const handleCreateProjectClose = () => {
    setEditOpen(false);
    setCurProjectIndex(0);
    setCurProject({});
  };
  const handleCreateProjectOpen = () => {
    setEditOpen(true);
  };

  const handleProjectFormOk = async (data: any) => {
    await updateProject({
      ...data
    });

    const len = projectList?.length || 0;
    // 所有项目处理完成
    if (len <= curProjectIndex + 1) {
      handleCreateProjectClose();
      await confirmAnnouncementOk();
      return;
    }

    await getcurrentProject(projectList, curProjectIndex + 1);
    setCurProjectIndex(curProjectIndex + 1);
  };

  // useEffect(() => {
  //   details.noticeCode && getNextNoticeList();
  // }, [details.noticeCode]);

  const getcurrentProject = async (list: any, index: number) => {
    const item = list[index] || {};
    const res: any = await projectDetail({
      noticeProjectCode: item.noticeProjectCode
    });

    setCurProject({
      ...res,
      // 招标公告  noticeType: '3'
      publishTime:
        details.noticeType === '3' && details.publishTime
          ? details.publishTime
          : res.publishTime
    });
    handleCreateProjectOpen();
  };

  const assignToDelear = async () => {
    const isNeedOperation = await checkNeedOperation?.();
    if (!isNeedOperation) return;
    setDelearModalOpen(true);
  };

  const onRevertConfirm = async () => {
    const params = {
      code: details.noticeCode,
      operatorUserId: userInfos.userId,
      operatorUserName: userInfos.realName
    };
    await noticeRecall(params);
    getAnnInfo();
    setRevertModalShow(false);
  };

  // 点击确认公告处理完成按钮
  const confirmAnnouncementClick = async () => {
    const isNeedOperation = await checkNeedOperation?.();
    if (!isNeedOperation) return;
    if (!isForward_disabled && details?.isFirst) {
      message.error('请先对该公告的所有标的物进行操作后，再确认公告处理完成。');
      return;
    }

    checkFirstNotice(async () => {
      const projecGeneraltList = await handleCurrentProject();

      if (details?.isFirst || !projecGeneraltList) {
        modalOpenHandle();
      } else {
        // 第二个及之后的公告，并且公告下有项目的logic
        getcurrentProject(projecGeneraltList, curProjectIndex);
      }
    });
  };

  // 处理当前公告下多个项目的流程
  const handleCurrentProject = async () => {
    const res = await getProjectList();
    setProjectList(res);
    setCurProjectIndex(0);
    return res;
  };

  const handleNextNotice = async (): Promise<boolean> => {
    const res = await getNextNoticeList();
    if (!res) {
      return false;
    }
    nextNoticeModalOpenHandle();
    setNoticeList(res);
    return !!res;
  };

  // 确认完成公告弹窗内确认按钮
  const confirmAnnouncementOk = async () => {
    checkFirstNotice(async () => {
      const { userInfo } = JSON.parse(
        localStorage.getItem('recoil-persist') || '{}'
      );

      await ProcessedNotice({
        noticeCode: details.noticeProjectCode || details.noticeCode,
        operatorUserId: userInfo.userId,
        operatorUserName: userInfo.realName
      });
      message.success('已确认完成！');
      modalCloseHandle();
      // if (details?.isFirst) {
      //   handleNextNotice();
      // }
      await handleNextNotice();
      // if (!hasNextNotice) {
      //   getAnnInfo();
      // }
      getAnnInfo();
    });
  };

  // const confirmAnn = async (isConfirm = false) => {
  //   if (!isForward_disabled && details?.isFirst) {
  //     message.error('请先对该公告的所有标的物进行操作后，再确认公告处理完成。');
  //     return;
  //   }
  //   checkFirstNotice(async () => {
  //     if (isConfirm) {
  //       const { userInfo } = JSON.parse(
  //         localStorage.getItem('recoil-persist') || '{}'
  //       );

  //       await ProcessedNotice({
  //         noticeCode: details.noticeProjectCode || details.noticeCode,
  //         operatorUserId: userInfo.userId,
  //         operatorUserName: userInfo.realName
  //       });
  //       message.success('已确认完成！');

  //       // navigate('/announcement');
  //       return;
  //     }
  //     if (!details?.isFirst) {
  //       setConfirmOpen(!confirmOpen);
  //     }
  //   });

  //   if (details?.isFirst && !isConfirm) {
  //     setConfirmOpen(!confirmOpen);
  //     return;
  //   }
  //   // setConfirmOpen(!confirmOpen);
  // };

  const onReturnConfirm = async () => {
    const params = {
      code: details.noticeCode,
      operatorUserId: userInfos.userId,
      operatorUserName: userInfos.realName
    };
    await dealerReturn(params);
    setReturnModalShow(false);
    navigate('/announcement');
  };

  const onDealerFinish = async (val: any) => {
    const { corpId, recordRemark, dispatchUserId } = val;
    const dispatchUserMap = getCityItem(dispatchUserId);

    if (userInfos.roleKeys === ROLE_KEYS_MAP.dealer) {
      const options: DealerTransferInterface = {
        noticeCode: details.noticeCode,
        userId: dispatchUserMap?.code ?? '',
        userName: dispatchUserMap?.label ?? '',
        noticeStatus: details?.noticeStatus,
        noticeStatusValue: details?.noticeStatusValue,
        recordRemark,
        currentProcessorUserId: userInfos.userId,
        currentProcessorUserName: userInfos.realName,
        scene: 1 // * 转交场景：  1.公告，5项目
      };
      await dealerTransfer(options);
    } else {
      const options: DispatchDealerInterface = {
        noticeCode: details.noticeCode,
        corpId,
        recordRemark,
        dispatchUserId: dispatchUserMap?.code ?? '',
        dispatchUserName: dispatchUserMap?.label ?? '',
        action: 15,
        scene: 1,
        sectorType: details.sectorType,
        sectorTypeValue: details.sectorTypeValue,
        dataFlag: details.dataFlag
      };
      await dispatchDealer(options);
    }
    message.success('操作成功');
    navigate('/announcement');
  };

  const onFinish = async (val: any) => {
    const salesInfo = val.sales && val.sales.split('-');
    const {
      userInfo: { userId, realName }
    } = JSON.parse(localStorage.getItem('recoil-persist') || '{}');

    await SalesTransfer({
      noticeCode: details.noticeCode,
      userId: salesInfo && salesInfo[0],
      userName: salesInfo && salesInfo[1],
      noticeStatus: details.noticeStatus,
      noticeStatusValue: details.noticeStatusValue,
      recordRemark: val.recordRemark,
      currentProcessorUserId: userId,
      currentProcessorUserName: realName,
      scene: 1,
      sectorType: val.sectorKey,
      sectorTypeValue: val.sector
    });
    message.success('转交成功');
    forwardAnn();
    navigate('/announcement');
  };

  useEffect(() => {
    if (open) {
      form.resetFields();
    }
  }, [open]);

  const forwardAnnouncementComponent = (
    <>
      {(userInfos.roleKeys === ROLE_KEYS_MAP.sales ||
        userInfos.roleKeys === ROLE_KEYS_MAP.dealer) &&
      !isFinishAction &&
      !isReturnAction ? (
        <Space size={'middle'} className="pc-forward-btn-container">
          {userInfos.roleKeys === ROLE_KEYS_MAP.dealer ||
          (userInfos.roleKeys === ROLE_KEYS_MAP.sales &&
            details?.noticeStatus !== NOTICE_STATUS.ToBeDealerConfirm) ? (
            <Button
              className="pc-forward-btn"
              type="primary"
              onClick={
                userInfos.roleKeys === ROLE_KEYS_MAP.dealer
                  ? assignToDelear
                  : forwardAnn
              }
            >
              转交整个公告
            </Button>
          ) : null}
          {userInfos.roleKeys === ROLE_KEYS_MAP.sales &&
          details.dataFlag === DataFlagEnum.dealer ? (
            details?.noticeStatus !== NOTICE_STATUS.ToBeDealerConfirm ? (
              <Button
                onClick={assignToDelear}
                className="pc-forward-btn pc-forward-btn-normal"
              >
                分配给经销商
              </Button>
            ) : (
              <Button
                type="default"
                className="pc-forward-btn"
                danger
                onClick={() => setRevertModalShow(true)}
              >
                <ReloadOutlined
                  rotate={-30}
                  style={{ transform: 'scaleX(-1)' }}
                />
                撤回公告
              </Button>
            )
          ) : null}
          <Button
            onClick={confirmAnnouncementClick}
            className="pc-forward-btn pc-forward-btn-normal"
          >
            确认公告处理完成
          </Button>
          {userInfos.roleKeys === ROLE_KEYS_MAP.dealer ? (
            <ZeissButton
              danger
              className="pc-forward-btn pc-footer-btn-revert"
              onClick={async () => {
                const isNeedOperation = await checkNeedOperation?.();
                if (!isNeedOperation) return;
                setReturnModalShow(true);
              }}
            >
              退回
            </ZeissButton>
          ) : null}
        </Space>
      ) : null}
      <ZeissModal
        width={520}
        open={confirmOpen}
        onCancel={modalCloseHandle}
        footer={null}
        destroyOnClose={true}
        centered
      >
        <div className="pc-forwardAnn-layout">
          <div className="pc-forwardAnn-title">是否确认公告处理完成？</div>
          <div>确认处理完成后，该条公告会出现在完成确认状态的公告列表中。</div>
          <Space className="pc-forwardAnn-footer" size="middle">
            <ZeissButton className="pc-normal-btn" onClick={modalCloseHandle}>
              取消
            </ZeissButton>
            <ZeissButton
              onClick={confirmAnnouncementOk}
              className="pc-confirm-btn"
            >
              确认完成
            </ZeissButton>
          </Space>
        </div>
      </ZeissModal>
      <AnnFooterPopup
        getAnnInfo={getAnnInfo}
        details={details}
        noticeCode={details.noticeCode}
        actionId={3}
        confirmCallback={onFinish}
        open={open}
        setOpen={setOpen}
      />
      <AnnFooterPopup
        getAnnInfo={getAnnInfo}
        details={details}
        noticeCode={details.noticeCode}
        actionId={8}
        confirmCallback={onDealerFinish}
        open={delearModalOpen}
        setOpen={setDelearModalOpen}
        dict={dict}
      />
      <NextNoticePopup
        open={isNextNoticeOpen}
        handleCancel={nextNoticeModalCloseHandle}
        handleOk={nextNoticeHandleOk}
      />
      <RevertModal
        title="是否撤回该公告?"
        open={revertModalShow}
        onCancel={() => setRevertModalShow(false)}
        onConfirm={onRevertConfirm}
      />
      <RevertModal
        title="是否退回该公告?"
        open={returnModalShow}
        onCancel={() => setReturnModalShow(false)}
        onConfirm={onReturnConfirm}
      />
      <CreateProject
        title="更新项目信息"
        mode={PROJECT_MODE.EDIT}
        okBtnText={
          projectList?.length === curProjectIndex + 1
            ? '确认更新'
            : '下一个项目'
        }
        projectList={projectList}
        step={curProjectIndex}
        stepItems={stepItems}
        formRef={form}
        noticeRecord={curProject}
        record={curProject}
        dicList={dict}
        handleOk={handleProjectFormOk}
        open={editOpen}
        setOpen={setEditOpen}
        systemCity={systemCity}
        handleCancel={handleCreateProjectClose}
      />
    </>
  );
  return {
    forwardAnnouncementComponent,
    confirmHandleAnn: confirmAnnouncementClick,
    // confirmHandleAnn: confirmAnnouncementOk,
    setConfirmOpen
  };
};
